import { ImageService } from "@DavisDigital/davisdigitalfrontend.module";

class ImageCollectionEditModalController {
    
    public isLoading = false;
    public collectionBackgroundColors;
    public imageSet;
	private focusableSelector = 'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])';
	
	// @ngInject
	constructor(
		public imageService   : ImageService,
		public ModalService,
		private davisAlertService,
		public $element,
		public $timeout       : ng.ITimeoutService,
	){}
	
	public $onInit = () => {
		
		for(var i=0; i<this.collectionBackgroundColors.options.length; i++){
			
			var option = this.collectionBackgroundColors.options[i];

			if(this.imageSet.backgroundColor === option.value){
				this.imageSet.backgroundColor = option; 
				break;
			}
		}

		// Move focus into the dialog once it renders so keyboard users start inside it
		this.$timeout(() => {
			const modalEl = this.$element[0].querySelector('.modal');
			if (modalEl) {
				modalEl.removeAttribute('aria-hidden');
				const closeBtn = modalEl.querySelector('.close') as HTMLElement;
				if (closeBtn) {
					closeBtn.focus();
				}
			}
		});
	}

	public handleKeydown = (event: KeyboardEvent) => {
		if (event.key === 'Escape' || event.keyCode === 27) {
			event.preventDefault();
			this.close();
			return;
		}

		if (event.key === 'Tab' || event.keyCode === 9) {
			this.trapFocus(event);
		}
	}

	// Keep Tab / Shift+Tab cycling within the dialog (WCAG 2.4.3)
	private trapFocus = (event: KeyboardEvent) => {
		const modalEl = this.$element[0].querySelector('.modal');
		if (!modalEl) return;

		// Skip disabled/hidden controls (e.g. Save while saving) so the wrap check still matches
		const focusableElements: HTMLElement[] = Array.prototype.filter.call(
			modalEl.querySelectorAll(this.focusableSelector),
			(el: HTMLElement) => !(el as HTMLButtonElement).disabled && el.getClientRects().length > 0
		);
		if (focusableElements.length === 0) return;

		const firstFocusable = focusableElements[0];
		const lastFocusable = focusableElements[focusableElements.length - 1];
		const active = document.activeElement as HTMLElement;
		const focusOutside = !modalEl.contains(active) || active === modalEl;

		if (event.shiftKey) {
			if (active === firstFocusable || focusOutside) {
				event.preventDefault();
				lastFocusable.focus();
			}
		} else if (active === lastFocusable || focusOutside) {
			event.preventDefault();
			firstFocusable.focus();
		}
	}

	public save = () =>{
		
		this.isLoading = true;
		
		this.imageSet.backgroundColor = this.imageSet.backgroundColor.value;
		
		this.imageService.saveImageSet(this.imageSet).then(
			(response)=>{
				console.log('respy', response);
			},
			(reason) =>{

			}
		).finally(()=>{
			this.close();
		})
		
		
		
	}
	
	public close = () =>{
		this.ModalService.closeModals();
	}
}
    

class ImageCollectionEditModal {
	public restrict: string = 'E';
	public scope:{};
	
	public bindToController = {
		close:'=',
		collectionBackgroundColors: '=?',
		imageSet:'=?'
	};

	public controller = ImageCollectionEditModalController;
	public controllerAs = 'imageCollectionEditModal';
	
	public templateUrl = __DAVIS_FRONTEND_BASE_PATH__ + '/davisdigital/directives/modals/image-collection-edit-modal.html';

	public static Factory() {
		return () => new this();
	}
}

export { ImageCollectionEditModal };
